<template>
    <div
        class="pa-0 d-flex justify-space-between align-center"
        style="width: 180px"
    >
        <nuxt-link
            :id="`shop-pn--viewProduct-${createPartNumberToSlug(item.pn)}`"
            :to="createProductLink(item)"
            class="shop-pn--viewProduct shop-viewProduct"
            ><TranslatableStringComponent v-if="item.isPartial" :tstring="{string: 'configurable'}" />
                <span v-else> {{item.pn}} </span>
            </nuxt-link
        >
        <FavoriteHeart :pn="item.pn" />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import FavoriteHeart from '~/components/FavoriteHeart.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
import { interpolateDOLStartersSlug } from '~/util/dol-staters-helper'

export default {
    name: 'ColumnPartNumber',
    components: {
        FavoriteHeart,
        TranslatableStringComponent,
    },
    data() {
        return {}
    },
    props: {
        item: {
            type: Object,
            default: null,
        },
    },
    methods: {
        createPartNumberToSlug(pn) {
            return pn.replace('/', '_')
        },
        createProductLink(item) {
            if (item.parent) {
                const path = this.localePath({
                    name: 'products-slug',
                    params: {
                        slug: interpolateDOLStartersSlug(item.parent[this.$i18n.locale].current),
                    },
                })
                if (this.isCustomProduct) {
                    return `${path}/${item.pn}/?isCustom=${this.isCustomProduct.hash}`
                } else {
                    return `${path}/${item.pn}/`
                }
            } else {
                return ''
            }
        },
        handleClipboard() {
            navigator.clipboard.writeText(this.item.pn)
            this.hitSnackbar( { string: 'partNumberCopiedSuccessfully' }, null)
        },
    },
    computed: {
        ...mapState('customProducts', ['customProductList']),
        isCustomProduct() {
            return (
                this.customProductList.length > 0 &&
                this.customProductList.find((i) => {
                    return i.hash === this.item.hash
                })
            )
        },
    },
}
</script>

<style></style>
